// ChatroomItem.js
import { connect } from 'react-redux';
import fetchMediaMenifestOfMessage from '../action/fetchMediaMenifestOfMessage.js';
import getChatroomData from '../selector/getChatroomData.js';
import getMessageData from '../selector/getMessageData.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import ChatroomItem from '../component/ChatroomItem.jsx';
import { FEATURE_DISPLAY_NAME } from '../RemoteConfigKeys.js';

function mapStateToProps(state, { id }) {
  const meId = getMeData(state, 'id');
  const username = getMeData(state, 'username');
  const participantId = getChatroomData(state, id, 'participantIds.0', true);
  const lastMessageId = getChatroomData(state, id, 'lastMessageId');
  const isMe = getMessageData(state, lastMessageId, 'senderId') === meId;
  const postedAtUnix = getMessageData(state, lastMessageId, 'postedAtUnix');
  return {
    id,
    participantId,
    lastMessageId,
    isMe,
    isDisplayNameEnabled:
      getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1,
    isPinned: getChatroomData(state, id, 'pinned'),
    type: getMessageData(state, lastMessageId, 'type'),
    caption: getMessageDataWithVariable(
      state,
      lastMessageId,
      'captionText',
      `${VariableName.USERNAME}:${username}`
    ),
    mediaType: getMessageData(state, lastMessageId, 'mediaType'),
    participantName: getUserData(state, participantId, 'username'),
    participantDisplayName: getUserData(state, participantId, 'displayName'),
    hasUnread: getChatroomData(state, id, 'hasUnread'),
    unreadCount: getChatroomData(state, id, 'unreadCount'),
    unreadGiftCount: getChatroomData(state, id, 'unreadGiftCount'),
    postedAtUnix,
    assetIds: getMessageData(state, lastMessageId, 'assetIds'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMediaMenifestOfMessage: messageId =>
      dispatch(fetchMediaMenifestOfMessage({ id: messageId })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatroomItem);
